export default __webpack_public_path__ + "412484e61b6644178f1d6bfc7cef31ea.svg";